import React, { FC, useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { SiteMetadataI, SocialI } from '../types/data-models'

interface HeaderI {
  location: Location
  siteMetadata: SiteMetadataI
  isSinglePost: boolean
}
const Header: FC<HeaderI> = ({ location, siteMetadata, isSinglePost }) => {
  const { title, description, logo, social, menuLinks } = siteMetadata
  const [transform, setTransform] = useState(false)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
  })

  useEffect(() => {
    return () => window.removeEventListener('scroll', handleScroll)
  })

  const handleScroll = (): void => {
    if (window.scrollY >= 140) {
      if (!transform) {
        setTransform(true)
      }
    } else {
      if (transform) {
        setTransform(false)
      }
    }
  }

  return (
    <div style={isSinglePost ? { marginTop: '4rem' } : {}}>
      {!isSinglePost && (
        <React.Fragment>
          <div id="intro" className={transform ? 'hidden' : ''} onScroll={handleScroll}>
            <h1>{title}</h1>
            {description}
            <ul className="actions">
              <li>
                <a href="#header" className="button icon solo fa-arrow-down scrolly">
                  Continue
                </a>
              </li>
            </ul>
          </div>
          <header id="header">
            <Link to="/" className="logo">
              {logo}
            </Link>
          </header>
        </React.Fragment>
      )}
      <nav id="nav">
        <ul className="links">
          {menuLinks &&
            menuLinks.length > 0 &&
            menuLinks.map((link) => (
              <li key={link.label} className={location?.pathname === link.url ? 'active' : ''}>
                <Link to={link.url}>{link.label}</Link>
              </li>
            ))}
        </ul>
        <ul className="icons">
          {social &&
            Object.keys(social).map((keyName, i) => (
              <li key={i}>
                <a href={social[keyName as keyof SocialI]} className={`icon fa-${keyName}`} aria-label={keyName}>
                  <span className="label">{keyName}</span>
                </a>
              </li>
            ))}
        </ul>
      </nav>
    </div>
  )
}

export default Header
